module.exports = __webpack_public_path__ + "media/images/icon-menu-644036f3a2d8c6314041b26bb9ade698.svg";